import uploadsaboutheadimageamberPinkJpg from "$lib/data/generated/uploads/about/Head/image/amber-pink.jpg";

export const uploads = {
  "uploads/about/Head/image/amber-pink.jpg": uploadsaboutheadimageamberPinkJpg
};